import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/frauds/admin', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const FraudsApi = {
  /**
   * Get flagged call QA results
   * @returns {Promise}
   */
  async getResults() {
    return await httpClient.get('/')
  },

  /**
   * Get a single call QA result with full analytics data
   * @param {string} id
   * @returns {Promise}
   */
  async getResultById(id) {
    return await httpClient.get('/' + encodeURIComponent(id))
  },
}

export default FraudsApi
